"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeConversion = exports.FAULT_RING_BUFFER_DATA_TYPES = exports.FAULT_EVENT_DETAIL_HEADER_TITLES = exports.FAULT_CODES = exports.FAULT_CODE_TITLES = void 0;
var FAULT_CODE_TITLES;
(function (FAULT_CODE_TITLES) {
    FAULT_CODE_TITLES["SN"] = "Service Now";
    FAULT_CODE_TITLES["SS"] = "Service Soon";
    FAULT_CODE_TITLES["SI"] = "Service Info";
    FAULT_CODE_TITLES["SU"] = "Unknown";
    FAULT_CODE_TITLES["SP"] = "Service Preventive Maintenance";
})(FAULT_CODE_TITLES = exports.FAULT_CODE_TITLES || (exports.FAULT_CODE_TITLES = {}));
var FAULT_CODES;
(function (FAULT_CODES) {
    FAULT_CODES["SN"] = "SN";
    FAULT_CODES["SS"] = "SS";
    FAULT_CODES["SU"] = "SU";
    FAULT_CODES["SI"] = "SI";
    FAULT_CODES["SP"] = "SP";
})(FAULT_CODES = exports.FAULT_CODES || (exports.FAULT_CODES = {}));
var FAULT_EVENT_DETAIL_HEADER_TITLES;
(function (FAULT_EVENT_DETAIL_HEADER_TITLES) {
    FAULT_EVENT_DETAIL_HEADER_TITLES["ACTUAL_TORQUE"] = "Actual Torque";
    FAULT_EVENT_DETAIL_HEADER_TITLES["BATTERY_VOLTAGE"] = "Battery Voltage";
    FAULT_EVENT_DETAIL_HEADER_TITLES["ENGINE_LOAD"] = "Engine Load";
    FAULT_EVENT_DETAIL_HEADER_TITLES["ENGINE_SPEED"] = "Engine Speed";
    FAULT_EVENT_DETAIL_HEADER_TITLES["ODOMETER"] = "Odometer";
    FAULT_EVENT_DETAIL_HEADER_TITLES["VEHICLE_SPEED"] = "Vehicle Speed";
})(FAULT_EVENT_DETAIL_HEADER_TITLES = exports.FAULT_EVENT_DETAIL_HEADER_TITLES || (exports.FAULT_EVENT_DETAIL_HEADER_TITLES = {}));
var FAULT_RING_BUFFER_DATA_TYPES;
(function (FAULT_RING_BUFFER_DATA_TYPES) {
    FAULT_RING_BUFFER_DATA_TYPES["ACTUAL_TORQUE"] = "0:61444:16";
    FAULT_RING_BUFFER_DATA_TYPES["BATTERY_VOLTAGE"] = "0:65271:48";
    FAULT_RING_BUFFER_DATA_TYPES["ENGINE_LOAD"] = "0:61444:56";
    FAULT_RING_BUFFER_DATA_TYPES["ENGINE_SPEED"] = "0:61444:24";
    FAULT_RING_BUFFER_DATA_TYPES["VEHICLE_SPEED"] = "0:65265:8";
})(FAULT_RING_BUFFER_DATA_TYPES = exports.FAULT_RING_BUFFER_DATA_TYPES || (exports.FAULT_RING_BUFFER_DATA_TYPES = {}));
exports.typeConversion = {
    SI: 'serviceInfo',
    SS: 'serviceSoon',
    SN: 'serviceNow',
    SP: 'servicePM',
};
